import { AlertTriangle } from 'lucide-react'
import { PayInvoiceButton } from './PayInvoiceButton'

/**
 * Bandeau du plan `unpaid` (Stripe a épuisé ses relances) : le compte est servi
 * en Découverte jusqu'au règlement de la facture, qui rétablit l'offre.
 */
export function UnpaidBanner() {
  return (
    <div
      role="alert"
      className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-warning/30 bg-warning/15 p-4"
    >
      <div className="flex items-start gap-3">
        <AlertTriangle aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-warning" />
        <div className="space-y-0.5">
          <p className="font-medium">Paiement en échec — régularisez votre facture</p>
          <p className="text-sm text-muted">
            Votre compte est limité à l’offre Découverte. Votre offre est rétablie dès le
            règlement de la facture.
          </p>
        </div>
      </div>
      <PayInvoiceButton size="sm" className="shrink-0" />
    </div>
  )
}
